<template>
    <v-container>
        <v-card class="card">
            <v-card-text>
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition" color="primary" rounded @click="filter_open = !filter_open">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn color="primary" @click="downloadReport">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        SALVAR RELATÓRIO
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <div v-show="filter_open" class="pa-5">
                        <v-row>
                            <v-col cols="6">
                                <DynamicSelect label="Flavor:" id="FlavorSelect" v-model="filtro.id_flavor"
                                               placeholder="Selecione a marca" endpoint="/dynamic-selects/flavors/id"
                                               :multiple="true" item-text="label" item-value="id" />
                            </v-col>
                            <v-col cols="6">
                                <DynamicSelect label="Empresa:" id="EmpresaSelect" v-model="filtro.id_empresa"
                                               placeholder="Selecione a empresa" endpoint="/dynamic-selects/empresas/id"
                                               :multiple="true" item-text="label" item-value="id" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field label="ID da Unidade de Negócio:"
                                              placeholder="Informe o ID da unidade de negócio" outlined
                                              v-model="filtro.id_unidade_negocio"
                                              v-input-filter="[$filters.numeric]" maxlength="10" />
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Código da Unidade de Negócio:"
                                              placeholder="Informe o código da unidade de negócio" outlined
                                              v-model="filtro.cd_unidade_negocio"
                                              v-input-filter="[$filters.numeric]" maxlength="6" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field label="Nome da Unidade de Negócio:"
                                              placeholder="Informe o nome da unidade de negócio" outlined
                                              v-model="filtro.nm_unidade_negocio" maxlength="500" />
                            </v-col>
                        </v-row>
                        <v-row class="justify-end">
                            <v-btn color="secondary" class="mr-4" @click="resetFilter">Limpar</v-btn>
                            <v-btn color="primary mr-n1" @click="filtrar">Filtrar</v-btn>
                        </v-row>
                    </div>
                </collapse-transition>
                <DataTable :headers="headers" :params="params" :filter="custom_filter"
                           url="/painel/datatable/unidades_negocio">
                    <template v-slot:items="{item}">
                        <td>
                            <v-menu :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" class="btn-acoes"
                                           v-bind="attrs"
                                           style="width: 52px;
                                           height: 48px;
                                           padding: 5px;
                                           margin: 10px;
                                           min-width: 48px;"
                                           v-on="on">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="editar(item)">
                                        <V-list-item-title>Editar</V-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="confirmExcluir(item.id_registro)">
                                        <V-list-item-title>Excluir</V-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td>{{ item.flavor.nome_amigavel }}</td>
                        <td class="text-center">
                            {{ item.id_unidade_negocio }}
                        </td>
                        <td>{{ item.empresa.cd_empresa_newcon + ' - ' + item.empresa.nm_empresa_newcon }}</td>
                        <td>{{ item.cd_unidade_negocio }}</td>
                        <td>{{ item.nm_unidade_negocio }}</td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
  import { AlertTypes } from '../../../plugins/alerts_types'
  import { alert, notification } from '../../../plugins/helpers'
  import * as Qs from 'qs'

  export default {
    name: 'ListagemUnidadesNegocio',
    props: {
      atualizaListagem: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        filter_open: false,
        headers: [
          { text: 'Ações', value: '', align: 'center' },
          { text: 'Flavor', value: 'flavor' },
          { text: 'ID Unidade de Negócio', value: 'id_unidade_negocio' },
          { text: 'Empresa', value: 'empresa' },
          { text: 'Código da Unidade de Negócio', value: 'cd_unidade_negocio' },
          { text: 'Nome da Unidade Negócio', value: 'nm_unidade_negocio' }
        ],
        params: {
          pagination: {
            rowsPerPage: 15,
            items_grid: 15,
            sortBy: 'id_registro',
            descending: true
          }
        },
        filtro: {
          id_flavor: [],
          id_empresa: [],
          id_unidade_negocio: null,
          cd_unidade_negocio: null,
          nm_unidade_negocio: null
        },
        custom_filter: {}
      }
    },
    watch: {
      atualizaListagem () {
        this.filtrar()
      }
    },
    methods: {
      filtrar () {
        this.custom_filter = { ...this.filtro }
      },
      resetFilter () {
        this.filtro = {
          id_registro: null,
          id_flavor: [],
          id_empresa: [],
          id_unidade_negocio: null,
          cd_unidade_negocio: null,
          nm_unidade_negocio: null
        }
        this.custom_filter = {}
      },
      editar (item) {
        this.$emit('editar', item)
      },
      async excluir (id_registro) {
        await this.$http.delete(`/painel/unidades_negocio/${id_registro}`).then(() => {
          notification(AlertTypes.SUCCESS, 'Unidade de negócio excluída com sucesso!')
        }).catch(() => {
          notification(AlertTypes.ERROR, 'Tivemos um erro ao excluir a unidade de negócio, sugerimos tentar novamente e se o problema persistir entre em contato com a Área de Suporte!')
        })
        this.filtrar()
      },
      downloadReport () {
        const filtros = { ...this.filtro }
        const headersExport = this.headers
          .filter(h => h.value)
          .map(h => h.value)

        const headersFormatadoExport = this.headers
          .filter(h => h.value)
          .map(h => h.text)
        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          headers: headersExport,
          headers_formatado: headersFormatadoExport
        }, {
          arrayFormat: 'brackets',
          encode: true
        })

        try {
          window.open(`${this.ws}/unidade_negocio/exportar?${encoded_params}`)
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
        }
      },
      confirmExcluir (id_registro) {
        alert({
          text: `Tem certeza que deseja excluir a unidade de negócio selecionada?\n Os dados atuais serão perdidos.`,
          buttons: {
            'Cancelar': () => {},
            'Confirmar': () => this.excluir(id_registro)
          }
        })
      }
    }
  }
</script>
<style>
.v-btn:not(.v-btn--round).v-size--default.btn-acoes {
    padding: 0px;
    min-width: 0;
    width: 48px;
    margin-right: 10px;
}
</style>
